import { render } from "./shop-ndds-bottom.vue?vue&type=template&id=6fbfff0a&scoped=true"
import script from "./shop-ndds-bottom.vue?vue&type=script&lang=js"
export * from "./shop-ndds-bottom.vue?vue&type=script&lang=js"

import "./shop-ndds-bottom.vue?vue&type=style&index=0&id=6fbfff0a&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbfff0a"]])

export default __exports__